<nz-image-group>
  <swiper #swiper [config]="configSwiper" (activeIndexChange)="setActiveSlide($event.activeIndex)">
    <ng-template *ngFor="let mediaItem of media; trackBy: trackBySource; index as i" swiperSlide>
      <app-lot-carousel-main-slider-item
        [mediaItem]="mediaItem"
        [index]="i"
        (click)="openPreview(mediaItem)"
        (loadingError)="mediaItemLoadingError(mediaItem)"
      ></app-lot-carousel-main-slider-item>
    </ng-template>
  </swiper>
  <div class="swiper-button-prev">
    <i nz-icon nzType="caret-left" nzTheme="outline"></i>
  </div>
  <div class="swiper-button-next">
    <i nz-icon nzType="caret-right" nzTheme="outline"></i>
  </div>
</nz-image-group>

<ng-container *ngIf="isUsingSavedMedia">
  <app-lot-carousel-main-slider-move-actions
    *akbCheck="['world.akebono.auto.auctioneer']"
    [lotId]="lotId"
    [lotType]="lotType"
    [lotSource]="lotSource"
    [activeSlideIndex]="activeSlideIndex"
    [media]="media"
    (mediaSaved)="mediaSaved.emit()"
    (mediaOrderChanged)="orderChanged($event)"
  ></app-lot-carousel-main-slider-move-actions>
</ng-container>
